import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { EnvironmentLabelComponent } from './shared/ui/environment-label/environment-label.component';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, EnvironmentLabelComponent],
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    // title = 'backoffice-angular';
}
